<template>
  <div class="addInfoWrap">
    <text-tip v-if="tipShow" class="textTip" @closeTip="closeTip">
      <div>
        授权码状态为“已激活”时，可点击【详情】查看该授权码激活后的详情信息。
      </div>
    </text-tip>
    <el-form
      :model="form"
      :rules="rules"
      ref="formRef"
      class="addFrom"
      @submit.native.prevent
    >
      <el-form-item label="授权码" label-width="65px" prop="code">
        <el-input
          v-model="form.code"
          placeholder="请输入授权码"
          style="width: 350px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="12px">
        <el-button type="primary" :loading="loading" @click="add"
          >追加</el-button
        >
        <el-button type="primary" :loading="loading" @click="batchAdd"
          >批量追加</el-button
        >
        <el-button type="primary" :loading="loading" plain @click="remove"
          >移除</el-button
        >
      </el-form-item>
    </el-form>
    <h3c-server-table
      class="serverTable"
      ref="tableObj"
      :url="url"
      :otherColumn="otherColumn"
      primaryKey="id"
      listKey="res.data"
      :defaultParam="defaultParam"
      @selection-change="handleSelectionChange"
    >
      <template v-for="column in columns">
        <el-table-column
          v-if="column.prop === 'licenseStatusName'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.licenseStatusName == '已生成'"
              style="color: #1db163"
            >
              {{ scope.row.licenseStatusName }}
            </div>
            <div
              v-else-if="scope.row.licenseStatusName == '已激活'"
              style="color: #4875f6"
            >
              {{ scope.row.licenseStatusName
              }}<span
                style="
                  font-size: 12px;
                  color: #961189;
                  cursor: pointer;
                  margin-left: 8px;
                "
                @click="jumpToDetail(scope, scope.row)"
                >详情</span
              >
            </div>
            <div v-else>{{ scope.row.licenseStatusName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="column.prop === 'effectiveDays'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.effectiveDays == -1 ? '永久' : scope.row.effectiveDays
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="column.prop"
          v-bind="column"
        ></el-table-column>
      </template>
    </h3c-server-table>
    <dialog-code-import
      v-if="dialogCodeImportFlag"
      :visible.sync="dialogCodeImportFlag"
      @cancelCodeImportDialog="cancelCodeImportDialog"
    ></dialog-code-import>
    <dialog-common
      v-if="dialogCommon"
      :visible.sync="dialogCommon"
      title="提示"
      @handleConfirm="handleConfirm"
      @handleClose="handleClose"
    >
      <img
        width="16"
        height="16"
        style="margin-right: 8px"
        src="../../../assets/img/warn.svg"
        alt=""
      />
      <span>您确认要移除选中项吗？</span>
    </dialog-common>
  </div>
</template>
<script>
import zgyLicenseReq from '~/request/zgyLicenseReq';
import h3cServerTable from '~/components/h3c-server-table-get.vue';
import textTip from '~/components/text-tip-zgy.vue';
import DialogCodeImport from './Dialog/DialogCodeImport.vue';
import DialogCommon from './Dialog/DialogCommon.vue';
export default {
  components: {
    h3cServerTable,
    textTip,
    DialogCodeImport,
    DialogCommon,
  },
  data() {
    return {
      otherColumn: {
        selection: {
          'reserve-selection': true,
          width: 45,
        },
        columnIndex: {
          width: 50,
        },
      },
      dialogCommon: false,
      currentCheck: [],
      loading: false,
      url: '',
      defaultParam: {},
      dialogCodeImportFlag: false,
      tipShow: true,
      form: {
        code: '',
      },
      rules: {
        code: [
          { required: true, message: '请输入授权码', trigger: [] },
          { validator: this.licenseKeyValidate, trigger: [] },
        ],
      },
      columns: [
        {
          prop: 'licenseNo',
          label: '授权码',
          minWidth: '300',
          'show-overflow-tooltip': true,
        },
        {
          prop: 'licenseSn',
          label: '软件条码',
          minWidth: '180',
          'show-overflow-tooltip': true,
        },
        {
          prop: 'displayFeatureName',
          label: '产品型号',
          minWidth: '110',
          'show-overflow-tooltip': true,
        },
        {
          prop: 'chineseDesc',
          label: '产品描述',
          minWidth: '130',
          'show-overflow-tooltip': true,
        },
        {
          prop: 'licenseStatusName',
          label: '授权码状态',
          minWidth: '110',
          'show-overflow-tooltip': true,
        },
        {
          prop: 'licenseTypeName',
          label: '授权码类型',
          minWidth: '110',
          'show-overflow-tooltip': true,
        },
        {
          prop: 'effectiveDays',
          label: '剩余有效时限（天）',
          minWidth: '160',
          'show-overflow-tooltip': true,
        },
      ],
    };
  },

  created() {
    if (sessionStorage.getItem('processNoForEmail'))
      sessionStorage.removeItem('processNoForEmail');
    if (sessionStorage.getItem('activeFileUrl'))
      sessionStorage.removeItem('activeFileUrl');
    if (sessionStorage.getItem('customerId'))
      sessionStorage.removeItem('customerId');
    if (sessionStorage.getItem('previousProcessFlag') == null) {
      //说明不是从上一步返回的
      if (sessionStorage.getItem('processNo'))
        sessionStorage.removeItem('processNo'); //每次清掉流程No
      const processNo = parseInt(new Date().getTime() / 1000);
      sessionStorage.setItem('processNo', processNo);
    }
    this.defaultParam = {
      processNo: sessionStorage.getItem('processNo'),
      currentStep: 1,
    };
    this.url = zgyLicenseReq.getListUrl;
    if (sessionStorage.getItem('previousProcessFlag'))
      sessionStorage.removeItem('previousProcessFlag'); //初始化之后清空流程
  },
  methods: {
    //-----------添加授权码
    add() {
      this.$refs.formRef.validateField(`code`, err => {});
    },
    licenseKeyValidate(rule, value, callback) {
        let param = {
          processNo: sessionStorage.getItem('processNo'),
          licenseNo: this.form.code,
        };
        this.loading = true;
        zgyLicenseReq
          .addAuthCode(param.processNo, param.licenseNo, '1')
          .then(res => {
            this.loading = false;
            if (res.code == '0') {
              this.form.code = '';
              this.refreshData();
            } else {
              callback(res.msg || '操作失败');
            }
          })
          .catch(error => {
            this.loading = false;
            callback('操作失败');
          });
    },
    //-----------删除授权码
    remove() {
      const currentCheck = this.getCurrentPageCheck();
      if (!currentCheck.length) {
        this.$notify({
          title: '提示',
          message: '请至少选择一个有效的授权码！',
          type: 'warning',
        });
        return;
      }
      this.dialogCommon = true;
    },
    handleClose() {
      this.dialogCommon = false;
    },
    handleConfirm() {
      const currentCheck = this.getCurrentPageCheck();
      const ids = currentCheck.map(item => item.licenseNo);
      const param = {
        processNo: sessionStorage.getItem('processNo'),
        licenseNos: ids,
      };
      zgyLicenseReq
        .remove(param)
        .then(res => {
          this.loading = false;
          if (res.code == '0') {
            this.$notify({
              title: '成功',
              message: res.msg || '操作成功',
              type: 'success',
            });
            this.refreshData();
            this.handleClose();
          }
        })
        .catch(error => {
          this.loading = false;
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        });
    },

    // 选中行
    checkTableRow(rows) {
      Promise.resolve().then(() => {
        this.$refs.tableObj.clearSelection();
        rows.forEach(row => {
          this.$refs.tableObj.toggleRowSelection(row, true);
        });
      });
    },

    refreshData() {
      this.$refs.tableObj.refreshData(); //刷新表格
    },
    handleSelectionChange(selection) {
      this.currentCheck = selection;
      this.$store.commit('setCheckTableData', this.currentCheck);
    },
    //批量添加
    batchAdd() {
      this.dialogCodeImportFlag = true;
    },
    cancelCodeImportDialog() {
      this.dialogCodeImportFlag = false;
      this.refreshData();
    },
    closeTip() {
      this.tipShow = false;
    },
    // 获取当前页选中数据
    getCurrentPageCheck() {
      // 当前页数据
      const formTableCurrent = this.$refs.tableObj.getFormTableCurrent();
      // 所有选中数据
      const currentCheck = this.currentCheck.slice();
      let result = [];
      formTableCurrent.forEach(item => {
        let flag = currentCheck.some(check => {
          return check === item;
        });
        flag && result.push(item);
      });
      return result;
    },
    //跳入下一页的验证
    getVail() {
      return new Promise((resovle, reject) => {
        resovle();
      });
    },
    //查看已激活的详情
    jumpToDetail(scope, row) {
      let sortNumber =
        scope.$index +
        (this.$refs.tableObj.currentPage - 1) * this.$refs.tableObj.pageSize +
        1;
      sessionStorage.setItem('sortNumber', sortNumber);
      sessionStorage.setItem('activeId', row.id);
      this.$router.push('/ZgyLicense/activeDetail');
    },
  },
};
</script>
<style lang="less" scoped>
.addInfoWrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .textTip {
    margin-bottom: 15px;
  }
  .addFrom {
    display: flex;
    z-index: 9;
    .el-form-item {
      // margin-bottom: 12px;
      /deep/ .el-form-item__label {
        color: #333333;
      }
      /deep/ .el-input__inner {
        color: #333333;
      }
    }
    .rightFlexItem {
      flex: 1;
      text-align: right;
    }
    .inputImgWrap {
      height: 100%;
      display: flex;
      align-items: center;
      .inputImgClass {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
      .rightClass {
        margin-right: 10px;
      }
    }
  }
  .serverTable {
    flex: 1;
    .productCode {
      cursor: pointer;
      color: @currentColor;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>